import React, { useState, useEffect, useContext } from 'react'

//Context
import { RequestorContext } from 'context/content-context'

//Components
import Header from 'components/Header'
import Footer from 'components/Footer'
import SecureModal from 'components/SecureModal'

//Styles
import styles from 'components/DocumentationLayout/DocumentationLayout.module.scss'

//API
import {cdcs, docsetCollection} from 'api/cdc'
import {access} from 'api/docset'
import {cdcSecureKey, docsetSecureKey} from 'api/secure'

interface Props {
  lang: string
  collection?: string
  cdc?: string
  docset: string
  cfr: string
  page: string
}

function RedirectLayout({lang, collection, cdc, docset, cfr, page}: Props) {
  const [showSecureModal, setShowSecureModal] = useState(false)
  const [cdcVersion, setCdcVersion] = useState('')
  const hash = window.location.hash
  const requestorId = useContext(RequestorContext)

  const submitKey = (accessKey: string): Promise<void> => {
    if (collection && cdc) {
      return cdcSecureKey(cdc, cdcVersion, accessKey).then(()=>{window.location.reload()})
    } else if (cdc) {
      return cdcSecureKey(cdc, cfr, accessKey).then(()=>{window.location.reload()})
    } else {
      return docsetSecureKey(docset,cfr, accessKey).then(()=>{window.location.reload()})
    }
  }


  useEffect(()=> {
    if (collection) {
      cdcs(collection, cfr, requestorId).then(cdcs => {
        let currCDC = cdcs.find( c => {return c.id === cdc})
        if (currCDC) {
          setCdcVersion(currCDC.version)
          let currDocset = currCDC.docsetCollection.docsets.find( d => {return d && d.id === docset})
          if (currDocset) {
            if (currDocset.isSecure && currDocset.isLocked) {
              setShowSecureModal(true)
            } else {
              let url = `./api/collections/${cdc}/${currCDC.version}/docsets/${docset}/content/${page}?locale=${lang}`
              window.location.replace(`${url}${hash}`)
            }
          }
          
        }
      })
    } else if (cdc) {
      docsetCollection(cdc, cfr).then( docsets => {
        let currDocset = docsets.docsets.find( d => {return d && d.id === docset})
        if (currDocset) {
          if (currDocset.isSecure && currDocset.isLocked) {
            setShowSecureModal(true)
          } else {
            let url = `./api/collections/${cdc}/${cfr}/docsets/${docset}/content/${page}?locale=${lang}`
            window.location.replace(`${url}${hash}`)
          }
        }
      })
    } else {
      access(docset,cfr).then(()=> {
        let url = `./api/docsets/${docset}/${cfr}/content/${page}?locale=${lang}`
        window.location.replace(`${url}${hash}`)
      }).catch( e => {
        if (e.response.status === 401) {
          setShowSecureModal(true)
        }
      }) 
    }
  }, []) /* eslint-disable-line */

  

  return (
    <>
      <SecureModal  show={showSecureModal} onHide={()=>{setShowSecureModal(false)}} submit={submitKey}></SecureModal>
      <div className={styles.header}><Header /></div>
      <div className={styles.main}></div>
      <div className={styles.footer}><Footer /></div>
    </>
  )
}
export default RedirectLayout